module.exports = __webpack_public_path__ + "img/logo-11.0adc3cb7.png";